<script setup lang="ts">
import { twoColumnLayoutToggleLeftKey } from "@/injectionKeys";
import Simplebar from "simplebar-vue";
import { provide, ref, useTemplateRef } from "vue";

const leftColumnScroller = useTemplateRef<InstanceType<typeof Simplebar>>("leftColumnScroller");
const rightColumnScroller = useTemplateRef<InstanceType<typeof Simplebar>>("rightColumnScroller");

const isLeftHidden = ref(false);

function toggleLeft() {
  isLeftHidden.value = !isLeftHidden.value;
}

defineExpose({
  leftColumnScroller,
  rightColumnScroller,
  toggleLeft,
});

provide(twoColumnLayoutToggleLeftKey, toggleLeft);
</script>

<template>
  <div class="two-columns-layout" :class="{ 'left-hidden': isLeftHidden }">
    <div class="left column">
      <slot name="leftPrelude" />
      <Simplebar ref="leftColumnScroller" class="scroller">
        <slot name="left" />
      </Simplebar>
    </div>

    <div class="right column">
      <Simplebar ref="rightColumnScroller" class="scroller">
        <slot name="rightPrelude" />
        <slot name="right" />
      </Simplebar>
    </div>
  </div>
</template>

<style scoped>
.two-columns-layout {
  --left-column-width: 25%;

  display: flex;
  min-height: 0;
  max-height: 100%;
  gap: var(--numbers-6);

  .column {
    min-width: 0;
    flex: 1;

    .scroller {
      height: 100%;
      max-height: 100%;
      padding-right: var(--numbers-10);
    }
  }

  .left.column {
    display: flex;
    max-width: 420px;
    flex: 0 0 var(--left-column-width);
    flex-direction: column;
    container-name: sidebar;
    container-type: inline-size;
    transition: flex-basis var(--animation-duration) var(--animation-easing);

    .scroller {
      min-height: 0;
      flex: 1;
    }
  }

  &.left-hidden {
    .left {
      flex: 0 0 8%;
    }
  }
}
</style>
